export default
{
  CustomersServices: [],
  CustomersService: {},
  StatusIDs: [],
  StatusID: {},
}
